$('.btn-burger').on('click', function(e) {
	e.preventDefault();
	$('body').toggleClass('menu-opened');
});

$(window).on('load resize', function() {
	if ($(window).width() <= 1023) {
		$('.js-mobile-nav:not(.js-mobile-nav-categories) > ul > li').each(function() {
			$(this).addClass('js-route');
		});
		$('.js-mobile-nav-categories ul > .menu__item--ancestor-active, .js-mobile-nav-categories ul > .menu__item--active').addClass(
			'js-show'
		);

		mobileNavigation();
	}
});

function mobileNavigation() {
	$('.js-mobile-nav .menu__item--has-dropdown > a').on('click', function(e) {
		const $this = $(this);
		if (!$this.parent().hasClass('js-show')) {
			e.preventDefault();

			$this
				.next()
				.slideDown()
				.parent()
				.addClass('js-show')
				.siblings()
				.removeClass('js-show')
				.find('.menu__dropdown')
				.slideUp()
				.find('.js-show')
				.removeClass('js-show');
		}
	});
}
